import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAction } from '../../classes/action';
import { IAAPDDentist } from '../../classes/dentist';
import { FindAPDSettings } from '../../classes/appSettings';

export interface FindAPDApiModel {
    requestingData: boolean;
    dentistList: any[];
    filteredDentistList: any[];
    currentBatch: number;
    noDentists: boolean;
    requestingSettings: boolean;
    totalDentists: number;
    totalPages: number;
    initialLoad: boolean;
}

export const defaultFindAPDApiModel: FindAPDApiModel = {
    requestingData: false,
    dentistList: [],
    currentBatch: 0,
    filteredDentistList: [],
    noDentists: false,
    requestingSettings: false,
    totalDentists: 0,
    totalPages: 0,
    initialLoad: true
};

export default function findAPDApiReducer(state: FindAPDApiModel = defaultFindAPDApiModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_NEXT_BATCH: {
            return assign({}, state, { requestingData: true, currentBatch: state.currentBatch + 1 });
        }

        case ActionType.RECIEVE_NEXT_BATCH: {
            const dentists = action.value.dentists;
            const noMoreToLoad = action.value.noMoreDentists;
            const dentistCount = action.value.totalDentists;
            const totalPages = action.value.totalPages;
            //do any needed grouping here

            const noDentists = dentists.length == 0 ? true : false;

            return assign({}, state, { initialLoad: false, requestingData: false, dentistList: dentists, noDentists: noDentists, totalDentists: dentistCount, totalPages: totalPages })
        }

        case ActionType.CLEAR_RESULTS: {
            return assign({}, state, { initialLoad: true, requestingData: false, dentistList: [], noDentist: false, totalDentists: 0, totalPages: 0})
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/reducers/find-a-pd-api.ts